function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "illustration-empty-a",
  width: 67.275,
  height: 41,
  x: 14.872,
  y: 9,
  rx: 1.6
}), /*#__PURE__*/React.createElement("mask", {
  id: "illustration-empty-c",
  width: 67.275,
  height: 41,
  x: 0,
  y: 0,
  fill: "#fff",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#illustration-empty-a"
})), /*#__PURE__*/React.createElement("rect", {
  id: "illustration-empty-b",
  width: 46,
  height: 41,
  x: 14.872,
  y: 9,
  rx: 1.6
}), /*#__PURE__*/React.createElement("mask", {
  id: "illustration-empty-d",
  width: 46,
  height: 41,
  x: 0,
  y: 0,
  fill: "#fff",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#illustration-empty-b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "illustration-empty-e",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#007CFF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 3,
  x: 8,
  y: 47,
  fill: "#E3E9F0",
  opacity: 0.6,
  rx: 1.5
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F5F8FA",
  stroke: "#B3BECD",
  strokeDasharray: "2 1",
  strokeWidth: 2,
  mask: "url(#illustration-empty-c)",
  xlinkHref: "#illustration-empty-a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  stroke: "#B3BECD",
  strokeDasharray: "2 1",
  strokeWidth: 2,
  mask: "url(#illustration-empty-d)",
  xlinkHref: "#illustration-empty-b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BECD",
  fillRule: "nonzero",
  d: "M35.2524591,25.9995771 L37.7269057,28.4741304 L40.2022066,25.9995771 C40.3757729,25.8260107 40.6451973,25.8067256 40.8400655,25.9417216 L40.9093133,25.9995771 C41.0828797,26.1731434 41.1021648,26.4425678 40.9671688,26.6374359 L40.9093133,26.7066838 L38.4339057,29.1811304 L40.9093133,31.6564313 C41.1045755,31.8516935 41.1045755,32.1682759 40.9093133,32.3635381 C40.7140512,32.5588002 40.3974687,32.5588002 40.2022066,32.3635381 L37.7269057,29.8881304 L35.2524591,32.3635381 C35.0788927,32.5371044 34.8094683,32.5563896 34.6146002,32.4213935 L34.5453523,32.3635381 C34.371786,32.1899717 34.3525008,31.9205473 34.4874969,31.7256792 L34.5453523,31.6564313 L37.0199057,29.1811304 L34.5453523,26.7066838 C34.3500902,26.5114217 34.3500902,26.1948392 34.5453523,25.9995771 C34.7406145,25.8043149 35.057197,25.8043149 35.2524591,25.9995771 Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.111,
  cy: 10.328,
  r: 8.675,
  fill: "#FFF",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#illustration-empty-e)",
  d: "M10.2826462,0 C15.9615949,0 20.5652925,4.60369753 20.5652925,10.2826462 C20.5652925,12.5923545 19.8037657,14.7241987 18.5180961,16.440795 L26.0090989,23.9316907 C26.5827594,24.5053511 26.5827594,25.4354385 26.0090989,26.0090989 C25.4354385,26.5827594 24.5053511,26.5827594 23.9316907,26.0090989 L23.9316907,26.0090989 L16.440795,18.5180961 C14.7241987,19.8037657 12.5923545,20.5652925 10.2826462,20.5652925 C4.60369753,20.5652925 0,15.9615949 0,10.2826462 C0,4.60369753 4.60369753,0 10.2826462,0 Z M10.2826462,2.93789893 C6.22625431,2.93789893 2.93789893,6.22625431 2.93789893,10.2826462 C2.93789893,14.3390382 6.22625431,17.6273936 10.2826462,17.6273936 C14.3390382,17.6273936 17.6273936,14.3390382 17.6273936,10.2826462 C17.6273936,6.22625431 14.3390382,2.93789893 10.2826462,2.93789893 Z",
  transform: "matrix(-1 0 0 1 26.44 0)"
}));

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 50,
    viewBox: "0 0 88 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.53b71851.svg";
export { ForwardRef as ReactComponent };